export const COURSE_HOMEPAGE = 'Course Homepage'
export const COURSE_TOOLKIT_PAGE = 'Course Toolkit Page'
